
document.addEventListener('DOMContentLoaded', function()    {

    (_ => {
        // hide the common ninja ribbon
        const appBlockSelector = '#shopify-block-common_ninja_all_in_one_suite_app_block_UxXttm div';
        const appBlock = document.querySelector(appBlockSelector);
        if ( appBlock ) {
            const waitInterval = setInterval(_ => {
                console.log( 'appBlock.shadowRoot -', appBlock.shadowRoot );
                if ( appBlock.shadowRoot )   {
                    appBlock.shadowRoot.append(
                        Object.assign(document.createElement('STYLE'), {
                            innerText: 
                                `div.commonninja-ribbon {
                                    position: absolute !important;
                                    top: -10000px !important;
                                    left: -10000px !important;
                                    width: 0 !important;
                                    height: 0 !important;
                                    pointer-events: none !important;
                                    overflow: hidden !important;
                                }
                                .inner img {
                                    height: auto !important;
                                }
                                .content:nth-child(even) .date-wrapper .inner {
                                    text-align: right;
                                }`
                        })
                    );
                    clearInterval(waitInterval);
                }
            }, 500);
        }
    })();

});